import { useNavigate } from "react-router-dom";
import Faq from "../../FAQ/faq";

const EnergyStorageSystems = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <div
        className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
        style={{
          backgroundImage: `url(/banner.png)`,
        }}
      >
        <div className="text-center  max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-2">
          {/* Heading */}
          <h1 className="text-brand-green text-2xl sm:text-3xl md:text-7xl leading-snug sm:leading-normal">
            Reliable and Scalable Power Storage for Every Need
          </h1>
          {/* Paragraph */}
          <p className="text-sm sm:text-base md:text-lg mt-4 text-black leading-relaxed">
            At Kyra Green Energy Solution, we provide advanced Energy Storage Systems (ESS) to store excess solar energy, ensuring uninterrupted power supply. Our ESS solutions are perfect for homes, businesses, and industrial applications, offering scalability, flexibility, and dependability.          </p>
        </div>
      </div>

      {/* Solutions Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-brand-green">
                Our Energy Storage Solutions
              </h2>

              <h3 className="text-lg font-semibold mt-4 text-brand-green">
                Lithium Iron Phosphate (LiFePO4) Battery
              </h3>
              <p className="text-gray-700 mt-2">
                Our LiFePO4 Battery provides high-performance, long-lasting energy storage for solar systems.
                Manufactured by Welson Power Technology, this 100Ah prismatic cell is perfect for residential,
                commercial, and industrial use, ensuring reliable and efficient energy storage.
              </p>

              <h4 className="text-md font-semibold mt-4">Key Benefits:</h4>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>Long cycle life with high efficiency</li>
                <li>Robust and safe with multiple built-in protections</li>
                <li>Ideal for various applications, from home solar setups to industrial plants</li>
              </ul>

              <h4 className="text-md font-semibold mt-4">Warranty &amp; Certification:</h4>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>1-Year Warranty</li>
                <li>BIS Certified for Quality Assurance</li>
              </ul>


              <button
                className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green "
                onClick={handleClick}

              >
                Request a Quote              </button>
            </div>

            <div className="flex justify-center">
              <div className="">
                <img
                  src="/solar-panel-wiring-diagram.png"
                  alt="LiFePO4 Battery Energy Storage System"
                // className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Benefits Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6 text-brand-green">
                Why Choose Our ESS Solutions?
              </h2>
              <p className="text-gray-700 mb-6">
                Kyra Green Energy Solution is more than a distributor — we’re your partner in clean energy.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  <strong>Long-Lasting Storage:</strong> Our lithium-based batteries ensure longer life cycles and consistent performance.
                </li>
                <li>
                  <strong>High Efficiency:</strong> Store excess solar power and use it when you need it most, reducing dependence on the grid.
                </li>
                <li>
                  <strong>Scalable Solutions:</strong> From 1kW to 600kW, our systems are tailored to meet both small and large-scale energy storage needs.
                </li>
                <li>
                  <strong>Smart Technology:</strong> Our ESS comes with smart control systems for optimized energy use and easy monitoring.
                </li>
              </ul>

              <button
                className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                onClick={handleClick}

              >
                Get a Free Consultation
              </button>
            </div>
            <div className="flex justify-center">
              <div className="">
                <img
                  src="/solar-panel-with-backup-battery.png"
                  alt="ESS System with Solar Panel and Battery"
                // className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dealer & Distributor Pricing Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-8 text-brand-green">
                Dealer & Distributor Pricing
              </h2>
              <p className="text-gray-700 mb-6">
                Our Energy Storage Systems are available at special pricing for both dealers and distributors, ensuring maximum value for your investment.
              </p>

              <h4 className="text-md font-semibold mt-4">Pricing:</h4>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>For Distributors: ₹[Insert Price] + GST per unit (Minimum 10 Units)</li>
                <li>For Dealers: ₹[Insert Price] + GST per unit (Minimum 3 Units)</li>
              </ul>

              <h4 className="text-md font-semibold mt-4">Package Offers:</h4>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>
                  Complete Solar Combo: 720W Panels + 6kW Hybrid Inverter + ESS at discounted pricing for dealers and distributors.
                </li>
              </ul>

              <button
                className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 bg-brand-green transition-colors"
                onClick={handleClick}
              >
                Talk to Our Sales Team
              </button>
            </div>

            <div className="flex justify-center">
              <div className="">
                <img
                  src="/solar-battery-storage-system.png"
                  alt="Solar panels with battery system for dealers and distributors"
                // className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Faq type="ess" />    </>
  );
};

export default EnergyStorageSystems;
